import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { IListaNegraModel } from 'src/app/models/interfaces/listanegra/IListaNegraModel';
import { ListaNegraModel } from 'src/app/models/listanegra/ListaNegraModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ListanegraService } from 'src/app/services/listanegra/listanegra.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-listanegra-registrar',
  templateUrl: './listanegra-registrar.component.html',
  styleUrls: ['./listanegra-registrar.component.css']
})
export class ListanegraRegistrarComponent implements OnInit {
  model: IListaNegraModel = new ListaNegraModel();
  listaTiposDocumento: ParametroModel[] = new Array<ParametroModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  constructor(
    private router: Router,
    private serviceListaNegra: ListanegraService,
    private storage: StorageService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { 
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.TiposDocumentosIdentidad).subscribe((data) => {
      this.listaTiposDocumento = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.serviceListaNegra.submit(this.model).subscribe((result) => {
            this.alertDialogService.open("La persona fue registrado");
            this.router.navigate(['/listanegra']);  
          });
        }
      });
    }
  }

}
